import React from 'react';

import {signUpRoot} from 'static/three-oh/src/modules/constants/routePaths';

import LinkButton from '../LinkButton';

export const JoinLink = React.forwardRef((props, ref) => {
  JoinLink.displayName = 'JoinLink';

  return (
    <LinkButton
      ref={ref}
      isHollow
      href={signUpRoot}
    >
      Join Now
    </LinkButton>
  );
});

export default JoinLink;
